import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function ResidencyCitizenshipInvestmentSaintLucia() {

    return (
        <main className='main'>
            <SEO
                title="Saint Lucia Citizenship by Investment | Caribbean CIP"
                description="Get Saint Lucia citizenship in 3–6 months. Enjoy visa-free travel, tax benefits, and flexible investment options under the official CIP program."
                keywords="Saint Lucia citizenship by investment, Caribbean CIP, Saint Lucia passport, second citizenship Caribbean, residency by investment Saint Lucia, CIU Saint Lucia, offshore citizenship program, global mobility passport"
                url="/residency-citizenship-investment-saint-lucia"
            />
            <IntroSection
                title="Residency & Citizenship by Investment – Saint Lucia"
                subtitle="Secure Second Citizenship or Residency in the Caribbean"
                description="Saint Lucia offers one of the most attractive Citizenship by Investment (CIP) programs in the world. With visa-free or visa-on-arrival access to 140+ countries, including the Schengen Area, UK, Hong Kong, and Singapore, Saint Lucia is ideal for investors, entrepreneurs, and families seeking global mobility and tax benefits. The program is administered by the Saint Lucia Citizenship by Investment Unit (CIU)."
                badges={[
                    "Citizenship in 3–6 Months",
                    "Residency via Incorporation or Real Estate",
                    "Multiple Investment Options"
                ]}
                buttonText="Request a Saint Lucia Residency & Citizenship Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/residency-passport/saint-lucia-citizenship.png')}
                imageAlt="Saint Lucia Citizenship by Investment"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Saint Lucia?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Strong Passport",
                                        text: "Visa-free access to 140+ countries."
                                    },
                                    {
                                        title: "Flexible Investment Routes",
                                        text: "Donation, real estate, bonds, or business investments."
                                    },
                                    {
                                        title: "Fast Processing",
                                        text: "Citizenship granted within 3–6 months."
                                    },
                                    {
                                        title: "Family Inclusion",
                                        text: "Covers spouse, children, and dependent parents."
                                    },
                                    {
                                        title: "Tax Neutrality",
                                        text: "No tax on foreign income, capital gains, or inheritance."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Citizenship by Investment (CIP) Options"
                        blocks={[
                            {
                                title: "National Economic Fund (Donation)",
                                items: [
                                    { text: "Minimum contribution: USD 100,000 (single applicant)." },
                                    { text: "USD 140,000 for main applicant + spouse." },
                                    { text: "USD 150,000 for a family of four." }
                                ]
                            },
                            {
                                title: "Real Estate Investment",
                                items: [
                                    { text: "Invest at least USD 300,000 in approved real estate projects." },
                                    { text: "Must be held for a minimum of 5 years." }
                                ]
                            },
                            {
                                title: "Government Bonds",
                                items: [
                                    { text: "Purchase non-interest-bearing government bonds of at least USD 300,000." },
                                    { text: "Held for a period of 5 years." }
                                ]
                            },
                            {
                                title: "Enterprise/Business Investment",
                                items: [
                                    { text: "Invest USD 3.5M (solo) or USD 6M (joint) in government-approved business projects." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Residency Options in Saint Lucia"
                        blocks={[
                            {
                                title: "Residency Routes",
                                items: [
                                    { text: "Local Company Incorporation: establish presence via IBC or local business." },
                                    { text: "Real Estate Ownership: investment grants renewable residency permits." },
                                    { text: "Work/Business Visas: for those operating regionally." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of Saint Lucia Citizenship & Residency'
                        services={[
                            {
                                title: "Global Mobility",
                                text: "Visa-free travel across Europe and key destinations."
                            },
                            {
                                title: "Security & Stability",
                                text: "Strong Commonwealth jurisdiction."
                            },
                            {
                                title: "Tax Neutrality",
                                text: "No tax on foreign income or wealth."
                            },
                            {
                                title: "Investment Flexibility",
                                text: "Multiple entry routes to citizenship or residency."
                            },
                            {
                                title: "Family Advantage",
                                text: "Citizenship is hereditary and covers family members."
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Application Process'
                        features={[
                            {
                                title: "Consultation & Eligibility Review",
                                text: "Assess applicant’s profile and select the best investment route."
                            },
                            {
                                title: "Investment Selection",
                                text: "Choose donation, real estate, bonds, or business investment."
                            },
                            {
                                title: "Application Preparation",
                                text: "Prepare due diligence, biometrics, and supporting documentation."
                            },
                            {
                                title: "CIU Submission",
                                text: "Application reviewed by the Saint Lucia Citizenship by Investment Unit."
                            },
                            {
                                title: "Approval & Citizenship",
                                text: "Passport issued typically within 3–6 months."
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "3–6 months."
                            },
                            {
                                name: "Minimum Investment",
                                description: "USD 100,000 (donation route)."
                            },
                            {
                                name: "Other Options",
                                description: "USD 300,000 for real estate or bonds."
                            },
                            {
                                name: "Government Fees & Due Diligence",
                                description: "Additional fees apply."
                            }
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={[
                            {
                                text: "Experts in Caribbean residency and citizenship programs."
                            },
                            {
                                text: "Full guidance on investment selection and structuring."
                            },
                            {
                                text: "Assistance with application, due diligence, and CIU filing."
                            },
                            {
                                text: "Comparative insights: Saint Lucia vs Dominica vs Antigua vs Cyprus."
                            },
                            {
                                text: "End-to-end support until passport or residency is granted."
                            }
                        ]}
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking for a second citizenship or Caribbean residency?"
                        description="Saint Lucia offers one of the fastest and most affordable citizenship programs in the world, with strong passport power and tax neutrality."
                        buttonText="Book a Saint Lucia Citizenship Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "How long does it take to obtain Saint Lucia citizenship?",
        answer: "3–6 months on average."
    },
    {
        question: "What is the cheapest option?",
        answer: "The USD 100,000 donation route."
    },
    {
        question: "Does Saint Lucia allow dual citizenship?",
        answer: "Yes — applicants can hold multiple citizenships."
    },
    {
        question: "Can I pass citizenship to my children?",
        answer: "Yes — Saint Lucia citizenship is hereditary."
    },
    {
        question: "Is Saint Lucia better than Dominica or Antigua?",
        answer: "Yes for passport strength, and more flexible investment options."
    }
];

const testimonialsData = [
    {
        quote: "Offshore Advisory helped me secure Saint Lucia citizenship in just 4 months. The process was professional and efficient.",
        author: "Michael R.",
        role: "Entrepreneur"
    },
    {
        quote: "Saint Lucia gave my family global mobility. Offshore Advisory managed everything from real estate investment to passport delivery.",
        author: "Sarah T.",
        role: "Investor"
    }
];
